import { availableSizes } from '../../utils'

export const avatarBackgroundColors = {
  gainsboro: 'gainsboro',
  pinkLace: 'pink-lace',
  paleLavender: 'pale-lavender',
  lavender: 'lavender',
  water: 'water',
  greenCyan: 'green-cyan',
} as const

export type AvatarBackgroundColor =
  (typeof avatarBackgroundColors)[keyof typeof avatarBackgroundColors]

export type AvatarSize = (typeof availableSizes)[number]

/**
 * @description check if a size is valid
 * @method isSizeValid
 * @param  {string} size
 * @return {boolean}
 */
export const isSizeValid = (size: AvatarSize): boolean =>
  availableSizes.indexOf(size) !== -1

/**
 * @description generates a random bg color class
 * @method generateRandomBgColor
 * @return {string}
 */
export const generateRandomBgColor = (username: string | undefined): string => {
  if (!username) {
    return avatarBackgroundColors.gainsboro
  }
  const colors = Object.values(avatarBackgroundColors)
  const split = username?.split(' ') ?? []
  const firstWord = split[0] ?? ''
  const second = split[1] ?? firstWord
  const initialsSize = firstWord.charCodeAt(0) - 65 + second.charCodeAt(0) - 65
  const sizeOfTheColors = colors.length

  let position = 0

  for (let index = 0; index < initialsSize; index++) {
    position++
    if (index === sizeOfTheColors || position === sizeOfTheColors) {
      position = 0
    }
  }

  return colors[position] ?? avatarBackgroundColors.gainsboro
}

/**
 * @description get initials from username
 * @method getInitials
 * @param  {string} username
 * @return {string}
 */
export const getInitials = (username: string | undefined): string => {
  if (!username) {
    return ''
  }

  const [firstWord, secondWord] = username.split(' ')

  if (firstWord && secondWord) {
    return `${firstWord.charAt(0)}${secondWord.charAt(0)}`
  }

  return `${firstWord?.charAt(0)}${firstWord?.charAt(1)}`
}
